import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Isvg from 'react-inlinesvg';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../../utils';

import { updateAppState } from '../../actions/applicationState';
import { logout } from '../../actions/user';

import AboutHero from '../../components/AboutHero';
import Body from '../../components/Body';
import DashboardHeader from '../../components/DashboardHeader';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import UnauthenticatedHeader from '../../components/UnauthenticatedHeader';
import { Theme } from '../../config/theme';

let styles;

const ICON1_ASSET = require('./assets/icon_1.svg');
const ICON2_ASSET = require('./assets/icon_2.svg');
const ICON3_ASSET = require('./assets/icon_3.svg');

const PAW_ASSET = require('./assets/paw.svg');

// const BANNER_ASSET = require('./assets/banner.png');

const FOUNDER_ASSET = require('./assets/founder.png');
const SIGNATURE_ASSET = require('./assets/signature.png');

const CV1_ASSET = require('./assets/cv_1.png');
const CV2_ASSET = require('./assets/cv_2.png');
const CV3_ASSET = require('./assets/cv_3.png');
const CV4_ASSET = require('./assets/cv_4.png');

class Story extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.openLoginHandler = this.loginModalOpenHandler.bind(this);
    this.logoutHandler = this.performLogout.bind(this);
    this.redirectHandler = this.performRedirect.bind(this);
  }

  performLogout() {
    this.props.dispatch(logout());
    this.props.history.push('/');
  }

  performRedirect(to) {
    this.props.history.push(to);
  }

  loginModalOpenHandler() {
    this.props.dispatch(
      updateAppState({
        login_modal_open: true,
      }),
    );
  }

  render() {
    return (
      <Body hasFooter>
        <SEO
          title="Our Story - Meet the Team Behind Dog Sharing"
          description={
            'Learn about The Dog Share Collective mission to connect dog lovers with dogs ' +
            "who need companionship. Founded by Sandra Walker, we're building a community " +
            "that enriches dogs' lives through trusted sharing."
          }
          keywords="dog sharing story, about dog share, sandra walker, dog collective"
          url="https://www.thedogsharecollective.com/story"
        />
        {this.props.user.isAuthenticated ? (
          <DashboardHeader
            logoutHandler={this.logoutHandler}
            redirectHandler={this.redirectHandler}
            {...this.props}
          />
        ) : (
          <UnauthenticatedHeader openLoginHandler={this.openLoginHandler} />
        )}
        <AboutHero />

        {/* Who we are */}
        <div className={css(styles.container, styles.container_white)}>
          <h2 className={css(styles.title)}>Who we are</h2>
          <p className={css(styles.content, styles.content_narrow)}>
            The Dog Share Collective is a community-led social enterprise that gets dogs the
            companionship they need. We get dogs social lives sorted by sharing dogs. Founded on the
            principles of promoting member defined good, The Dog Share Collective is shaped by those
            who we serve; our members and their dogs. Sharing anything{' '}
            {'"involves mutual assistance'}
            {' in working towards a common goal"'}. Together, we share values of connection, caring
            for others, social responsibility and cooperative spirit.
          </p>
        </div>

        {/* What we do */}
        <div className={css(styles.container)}>
          <h2 className={css(styles.title)}>What we do</h2>
          <div className={css(styles.whatwedo_blocks)}>
            <div className={css(styles.whatwedo_block)}>
              <Isvg cacheGetRequests src={ICON1_ASSET} className={css(styles.whatwedo_icon)} />
              <div className={css(styles.whatwedo_title)}>
                We make access easy for
                <span className={css(styles.highlight)}> people without dogs</span>
              </div>
            </div>
            <div className={css(styles.whatwedo_block)}>
              <Isvg cacheGetRequests src={ICON2_ASSET} className={css(styles.whatwedo_icon)} />
              <div className={css(styles.whatwedo_title)}>
                We bring peace of mind to
                <span className={css(styles.highlight)}> people with dogs</span>
              </div>
            </div>
            <div className={css(styles.whatwedo_block)}>
              <Isvg cacheGetRequests src={ICON3_ASSET} className={css(styles.whatwedo_icon)} />
              <div className={css(styles.whatwedo_title)}>
                We help
                <span className={css(styles.highlight)}> dogs </span>
                live better lives
              </div>
            </div>
          </div>
          <p className={css(styles.content)}>
            The Dog Share Collective connects people who want more dog in their life, with people
            who want to find more life for their dog. Like us, dogs are social animals.
            Companionship is everything to a dog. What we do is life-giving. For the dog. For
            dog-less people. For dog owners.
          </p>
        </div>

        {/* Where we're heading */}
        <div className={css(styles.container, styles.container_white)}>
          <h2 className={css(styles.title)}>{"Where we're heading"}</h2>
          <p className={css(styles.content, styles.content_narrow)}>
            At first, The Dog Share Collective was simply imagined as a place where any dog could
            find a new best friend, by connecting with a local dog-lover…
          </p>
          <div className={css(styles.where_points)}>
            <p className={css(styles.content, styles.content_narrow)}>
              To help <strong className={css(styles.bold)}>683,000 NZ dogs </strong>
              live better lives
            </p>
            <Isvg cacheGetRequests src={PAW_ASSET} className={css(styles.paw_icon)} />
            <p className={css(styles.content, styles.content_narrow)}>
              To make dog access easy for the
              <strong className={css(styles.bold)}> 232,700 New Zealanders </strong>
              who wanted a dog as a companion in their life, but {"couldn't"} commit to owning one
            </p>
            <Isvg cacheGetRequests src={PAW_ASSET} className={css(styles.paw_icon)} />
            <p className={css(styles.content, styles.content_narrow)}>
              To bring dog companionship support to the
              <strong className={css(styles.bold)}> 28% of NZ households</strong> who own dogs, in a
              meaningful, socially sensible and economically sustainable way
            </p>
            <Isvg cacheGetRequests src={PAW_ASSET} className={css(styles.paw_icon)} />
            <p className={css(styles.content, styles.content_narrow)}>
              To build a collective of dog-lovers to help {"NZ's"} widest dog community, by giving
              back
            </p>
          </div>
          <p className={css(styles.content, styles.content_narrow)}>
            As we have grown, so has our {"collective's"} motivation to do more and be more. Whilst
            our focus will always be providing a super functional, safe and secure online
            environment where people can co-create better lives themselves, for the good of dogs, we
            reckon we have loads more good up our sleeve for dogs.
          </p>
        </div>

        {/* Banner */}
        <div className={css(styles.banner)}>
          <p className={css(styles.banner_text)}>
            Today, we are leaders in the world of dog companionship.
          </p>
          <p className={css(styles.banner_text)}>
            Tomorrow, we will lead in the world of dog collectives.
          </p>
        </div>

        {/* Founder */}
        <div className={css(styles.container, styles.container_white, styles.container_founder)}>
          <h2 className={css(styles.title)}>Meet our founder</h2>
          <div className={css(styles.founder)}>
            <img className={css(styles.founder_photo)} src={FOUNDER_ASSET} alt="Sandra Walker" />
            <div className={css(styles.founder_content)}>
              <h3 className={css(styles.founder_name)}>Sandra Walker</h3>
              <div className={css(styles.founder_titles)}>
                MMGT, PGDIP (OPS MGMT), GDIP (HR)
                <br />
                {"Chief Dog's Body"} | Founder of The Dog Share Collective
              </div>
              <div className={css(styles.founder_bio)}>
                <p className={css(styles.founder_paragraph)}>
                  Hello awesome you! Thank you for being a part of this movement. Together we are
                  disrupting things a bit to make life better for dogs. And {"it's"} wonderful to
                  watch it happen for you. After my dog Pearl died, I {"couldn't"} commit to another
                  dog full time. Flat out with a career driving ships for the Navy and regularly
                  deploying overseas, I was dog-less for way too many years. Then the Bailey Family
                  changed my life, by letting me share their dog Tess for four years.
                </p>
                <p className={css(styles.founder_paragraph)}>
                  I have no experience in running a dog organisation, but after becoming the biggest
                  dog sharing advocate ever, I started this Collective to give all dogs and dog
                  lovers the same life giving joy that I found from sharing my life with Tess and
                  The Bailey Family. You see…what I once wanted for one dog, I now want for all dogs
                  and what I once wanted for myself, I now want for everybody.
                </p>
                <p className={css(styles.founder_paragraph)}>
                  Why? Because I think the boring stuff in life prevents us dog lovers from doing
                  what we really want to be doing, which is hanging out with dogs. And dogs have
                  been waiting for us to find a way to work this problem out. Finally, we have.
                  Through trusted dog sharing we can now enrich {"dogs'"} lives, and our own lives,
                  and still do the boring stuff!
                </p>
                <p className={css(styles.founder_paragraph)}>
                  So {"here's"} to you, us, and more happy dog time
                  <span role="img" aria-label="Smiley Emoji">
                    {' '}
                    😊
                  </span>
                </p>
              </div>
              <img
                className={css(styles.founder_signature)}
                src={SIGNATURE_ASSET}
                alt="Sandra's Signature"
              />
              <span className={css(styles.founder_signoff)}>Sandra</span>
            </div>
          </div>
        </div>

        {/* Sharing CV */}
        <div className={css(styles.container, styles.container_white)}>
          <h2 className={css(styles.cv_title)}>{"P.S. Here's my dog sharing CV"}</h2>
          <div className={css(styles.cv_dogs)}>
            <div className={css(styles.cv_dog)}>
              <img className={css(styles.cv_photo)} src={CV1_ASSET} alt="Sandra &amp; Pearl" />
              <div className={css(styles.cv_dog_name)}>Pearl</div>
              <div className={css(styles.cv_dog_breed)}>Staffordshire Cross</div>
              <div className={css(styles.cv_dog_bio)}>
                Rescued off the street. My best friend for 13 years. She was shared with my parents
                every time I deployed overseas.
              </div>
            </div>
            <div className={css(styles.cv_dog)}>
              <img className={css(styles.cv_photo)} src={CV2_ASSET} alt="Sandra &amp; Carly" />
              <div className={css(styles.cv_dog_name)}>Carly</div>
              <div className={css(styles.cv_dog_breed)}>Black Labrador</div>
              <div className={css(styles.cv_dog_bio)}>
                One very special Epilepsy Assistance Dog who I fostered for 7 months. My colleagues
                at work and the Air New Zealand staff fell in love with her!
              </div>
            </div>
            <div className={css(styles.cv_dog)}>
              <img className={css(styles.cv_photo)} src={CV3_ASSET} alt="Sandra &amp; Tess" />
              <div className={css(styles.cv_dog_name)}>Tess</div>
              <div className={css(styles.cv_dog_breed)}>Border Collie</div>
              <div className={css(styles.cv_dog_bio)}>
                Owned by The Bailey Family, just around the corner from my home and gratefully
                shared with me for 4 years. She inspired all of this.
              </div>
            </div>
            <div className={css(styles.cv_dog)}>
              <img className={css(styles.cv_photo)} src={CV4_ASSET} alt="Sandra &amp; Finbar" />
              <div className={css(styles.cv_dog_name)}>Finbar</div>
              <div className={css(styles.cv_dog_breed)}>Irish Wheaten Terrier</div>
              <div className={css(styles.cv_dog_bio)}>
                Owned by The Johnsons and shared with me for 3 weeks while they were overseas. I dog
                sat Finbar in her house and we had a ball.
              </div>
            </div>
          </div>
        </div>
        <Footer user={this.props.user} />
      </Body>
    );
  }
}

Story.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

styles = StyleSheet.create({
  cv_title: {
    marginBottom: 40,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 20,
    lineHeight: 1.5,
    textAlign: 'center',
    color: '#262626',
  },
  cv_dogs: {
    display: 'flex',
    justifyContent: 'space-between',
    width: Theme.container_width,
    margin: '0 auto 75px',

    [Theme.mobile_query]: {
      width: 'auto',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 0,
    },

    '@media screen and (max-width: 1170px)': {
      width: 'auto',
      flexWrap: 'wrap',
    },
  },
  cv_dog: {
    width: 202,
    textAlign: 'center',

    '@media screen and (max-width: 1170px)': {
      width: '50%',
      marginBottom: 50,
      padding: '0 30px',
    },

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  cv_photo: {
    display: 'block',
    height: 180,
    width: 180,
    margin: '0 auto 22px',
    borderRadius: '50%',
  },
  cv_dog_name: {
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 20,
    lineHeight: 1.5,
    color: '#262626',
  },
  cv_dog_breed: {
    marginBottom: 20,
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 14,
    color: '#828282',
  },
  cv_dog_bio: {
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    lineHeight: 1.4,
  },
  container_founder: {
    '@media screen and (max-width: 810px)': {
      padding: '70px 0',
    },
  },
  founder: {
    display: 'flex',
    justifyContent: 'space-between',
    width: Theme.container_width,
    margin: '55px auto -70px',
    padding: 60,
    borderRadius: 6,
    backgroundColor: '#f5f5f5',
    border: 'solid 1px #e4e4e4',

    '@media screen and (max-width: 1170px)': {
      width: 'auto',
    },

    '@media screen and (max-width: 810px)': {
      flexDirection: 'column',
      alignItems: 'center',
    },

    [Theme.mobile_query]: {
      borderRadius: 0,
      borderLeft: 0,
      borderRight: 0,
    },
  },
  founder_photo: {
    display: 'block',
    width: 274,
    height: 274,
    borderRadius: '50%',
    marginRight: 80,

    '@media screen and (max-width: 810px)': {
      marginBottom: 30,
      marginRight: 0,
    },
  },
  founder_content: {
    width: 694,

    '@media screen and (max-width: 810px)': {
      width: 'auto',
    },
  },
  founder_name: {
    marginBottom: 20,
    fontSize: 20,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    lineHeight: 1.5,
    color: '#262626',
  },
  founder_titles: {
    marginBottom: 25,
    fontSize: 13,
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    textTransform: 'uppercase',
    letterSpacing: 1.8,
    lineHeight: 2,
    color: '#a5a5a5',
  },
  founder_paragraph: {
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    lineHeight: 1.4,

    ':not(:last-child)': {
      marginBottom: 15,
    },
  },
  founder_signature: {
    display: 'block',
    margin: '20px 0',
  },
  founder_signoff: {
    fontFamily: Theme.font_family_primary,
    fontWeight: Theme.font_weight_primary,
    fontSize: 15,
    color: '#000e1f',
    lineHeight: 1.4,
  },
  highlight: {
    color: Theme.turquoise,
  },
  container: {
    padding: '70px 15px',
  },
  container_white: {
    backgroundColor: Theme.white,
  },
  title: {
    marginBottom: 24,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 30,
    lineHeight: 1.17,
    color: '#262626',
    textAlign: 'center',
  },
  content: {
    maxWidth: 826,
    margin: '0 auto 20px',
    fontFamily: Theme.font_family_primary,
    fontSize: 18,
    lineHeight: 1.72,
    textAlign: 'center',
    color: '#000e1f',

    [Theme.mobile_query]: {
      padding: '0 20px',
      fontSize: 15,
    },
  },
  bold: {
    fontWeight: 900,
  },
  content_narrow: {
    maxWidth: 750,
  },
  whatwedo_blocks: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 46,
    marginTop: 45,

    [Theme.mobile_query]: {
      width: 'auto',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: 16,
    },
  },
  whatwedo_block: {
    width: 290,
    margin: '0 35px',
    textAlign: 'center',

    [Theme.mobile_query]: {
      marginBottom: 30,
    },
  },
  whatwedo_icon: {
    display: 'inline-block',
    height: 130,
    width: 130,
    marginBottom: 23,
  },
  whatwedo_title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 20,
    lineHeight: 1.5,
    fontWeight: Theme.font_weight_heading,
    color: '#262626',
  },
  where_points: {
    marginTop: 40,
  },
  paw_icon: {
    display: 'block',
    width: 20,
    height: 18,
    margin: '0 auto 10px',
  },
  banner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 500,
    // paddingLeft: 200,
    // backgroundImage: `url('${BANNER_ASSET}')`,
    backgroundColor: 'rgb(253, 253, 253)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: '50px 20px',
    },
  },
  banner_text: {
    width: 691,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
    fontSize: 45,
    textAlign: 'center',
    lineHeight: 1.16,
    color: Theme.turquoise,

    ':not(:last-child)': {
      marginBottom: 40,
    },

    [Theme.mobile_query]: {
      width: 'auto',
      fontSize: 30,
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Story);



// WEBPACK FOOTER //
// ./src/views/Story/index.js